import * as html2pdf from 'html2pdf.js';
import * as React from 'react';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import { IChangeRegion } from '../../actions';
import { IBudget } from '../../types/store/budget';
import { IRouterData } from '../../types/store/routerData';
import { ISlotsItems } from '../../types/store/slotsItems';
import { getAllMaterials } from '../../utils/manageBudgetMaterial';
import ItemBudget from './ItemBudget';

interface IBudgetProps {
  changeRegion: IChangeRegion;
  budget: IBudget;
  slotsItems: ISlotsItems;
  routerData: IRouterData;
}

function toggleDisplay(elems: HTMLCollection, display: string) {
  for (var i = 0; i < elems.length; i++) {
    var elem = elems[i] as HTMLElement;
    elem.style.display = display;
  }
}

const Budget: React.SFC<IBudgetProps> = props => {
  const state = { region: undefined };

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    props.changeRegion(event.target.value);
  };

  const allPortsBudgetItems = props.budget.slots.front.slotsSpecs.concat(props.budget.slots.back.slotsSpecs);

  const allMaterials = getAllMaterials(allPortsBudgetItems, props.slotsItems, props.budget, props.routerData);

  const xlsLogoStyle = { background: '#000', color: '#FFF', fontSize: 14, textAlign: 'left', height: 30 };

  const xlsHeaderTextStyle = { textAlign: 'left', fontSize: 11 };

  const xlsSubHeaderTextStyle = { textAlign: 'left', fontSize: 10 };

  const xlsHeaderLinkStyle = { fontSize: 10 };

  const xlsTitleRowStyle = { fontSize: 12 };

  const xlsTotalRowStyle = { background: '#73389b', color: '#FFF' };

  const pdfToHTML = () => {
    document.getElementsByTagName('body')[0].classList.add('renderPDF');
    var root = document.getElementById('root');
    var elems = document.getElementsByClassName('hidePDF') as HTMLCollection;
    toggleDisplay(elems, 'none');
    var html = root!.innerHTML;
    html2pdf(html, {
      margin: 0,
      filename: 'M4300-96X-Configuration.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { dpi: 192, letterRendering: true },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    });
    toggleDisplay(elems, 'block');
    document.getElementsByTagName('body')[0].classList.remove('renderPDF');
  };

  return (
    <div className="section col-md-12">
      <div className="section-table">
        <h3 className="section-title">M4300-96X bill of materials</h3>
        <div className="results-table">
          <div className="form-group">
            <label>Region</label>
            <select value={state.region} onChange={handleChange}>
              <option value="North America, Europe">North America, Europe</option>
              <option value="Asia Pacific">Asia Pacific</option>
            </select>
          </div>
          <table id="react-html-table-to-excel">
            <thead className="xls-export-component">
              <tr>
                <th colSpan={3} style={xlsLogoStyle}>
                  NETGEAR Business
                </th>
              </tr>
            </thead>
            <thead className="xls-export-component">
              <tr>
                <th />
                <th />
                <th />
              </tr>
            </thead>
            <thead className="xls-export-component">
              <tr>
                <th colSpan={3} style={xlsHeaderTextStyle}>
                  M4300-96X: Up to 96-port 10G or 24-port 40G
                </th>
              </tr>
            </thead>
            <thead className="xls-export-component">
              <tr>
                <th colSpan={3} style={xlsSubHeaderTextStyle}>
                  Modular. Granular. Unique.
                </th>
              </tr>
            </thead>
            <thead className="xls-export-component">
              <tr>
                <th colSpan={3} style={xlsHeaderTextStyle}>
                  <a style={xlsHeaderLinkStyle} href="https://netgear.com/m4300">
                    M4300 Product Page
                  </a>
                </th>
              </tr>
            </thead>
            <thead className="xls-export-component">
              <tr>
                <th colSpan={3} style={xlsHeaderTextStyle}>
                  <a href="https://netgear.com/96x-config">M4300-96X Configurator</a>
                </th>
              </tr>
            </thead>
            <thead className="xls-export-component">
              <tr>
                <th />
                <th />
                <th />
              </tr>
            </thead>
            <thead className="xls-export-component">
              <tr>
                <th colSpan={3} style={xlsTitleRowStyle}>
                  M4300-96X BILL OF MATERIALS
                </th>
              </tr>
            </thead>
            <thead className="xls-export-component">
              <tr>
                <th colSpan={3}>{props.budget.region}</th>
              </tr>
            </thead>
            <thead className="xls-export-component">
              <tr>
                <th />
                <th />
                <th />
              </tr>
            </thead>
            <thead className="table-header d-none d-md-block">
              <tr className="table-row">
                <th className="table-col prd-desc">Description</th>
                <th className="table-col sku">Ordering SKU</th>
                <th className="table-col quantity">Quantity</th>
              </tr>
            </thead>
            <tbody className="table-content">
              {allMaterials.map(material => <ItemBudget key={material.id} {...material} />)}
            </tbody>

            <tfoot className="table-footer d-none d-md-block">
              <tr className="table-row">
                <th className="table-col table-col-total" style={xlsTotalRowStyle}>
                  Total
                </th>
                <th className="table-col" style={xlsTotalRowStyle}>
                  {' '}
                </th>
                <th className="table-col quantity" style={xlsTotalRowStyle}>
                  {allMaterials.reduce((sum, item) => sum + item.qty, 0)}
                </th>
              </tr>
            </tfoot>
          </table>
        </div>
        <div className="table-buttons hidePDF">
          <button type="button" className="button icon pdf" onClick={pdfToHTML}>
            Download as PDF
          </button>
          <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className="download-table-xls-button button icon xls"
            table="react-html-table-to-excel"
            filename="M4300-96X-BOM"
            sheet="M4300-96X BOM"
            buttonText="Download as XLS"
          />
          <button type="button" className="button icon email" style={{ display: 'none' }}>
            Send by email
          </button>
        </div>
      </div>
    </div>
  );
};

export default Budget;



// WEBPACK FOOTER //
// ./src/components/Budget/index.tsx